import { IMicroServiceItem, IMicroServiceListItem } from '../IMicroServiceDataSource';
import * as Properties from './Properties';
import { MicroServicePropertiesValueType } from './Properties';

export function fixMediaBaseUrl(mediaBaseUrl: string, env: string) {
    if (mediaBaseUrl === 'https://media.cloudapp.net') {
        // Devhosts and media microservice both use the srr cookie, so we need to fix it for devhosts for it to work
        // These urls will need to be changed as the endpoints change
        if (env === 'edog') {
            return 'https://centralus1-mediad.svc.ms';
        } else {
            return 'https://northcentralus1-medias.svc.ms';
        }
    }

    return mediaBaseUrl;
}

export function getItemUrlWithToken(url: string, driveAccessToken: string): string {
    // handle search urls: basically search does not have spItemUrl and wont have it because, search can have multiple users files
    // so always we use spResourceUrl in search which has the token on it already.
    if (url.toLowerCase().indexOf('access_token') > 0) {
        return url;
    }

    const concatString = url.indexOf('?') === -1 ? '?' : '&';

    return `${url}${concatString}${driveAccessToken.indexOf('access_token') > -1 ? driveAccessToken : `access_token=${driveAccessToken}`}`;
}

export function getNormalUrl(
    properties: MicroServicePropertiesValueType,
    targetPropertyName: string,
    item: IMicroServiceItem | IMicroServiceListItem | undefined,
    method?: string,
    viewOnlyExperienceEnabled?: boolean,
    supportsCookies?: boolean
) {
    let url = properties[targetPropertyName];
    if (!url) {
        return undefined;
    }

    url = url.replace('{.method}', method);

    const regex = /{[^}]*}/;
    let part = regex.exec(url);
    while (part && part[0]) {
        const propertyName = part[0].substring(1, part[0].length - 1);
        let propertyValue: string;

        if (propertyName === Properties.ALL.itemUrl || propertyName === Properties.ALL.fileType) {
            propertyValue = item && item[propertyName];

            if (targetPropertyName === Properties.ALL.zipUrl && propertyName === Properties.ALL.fileType && !propertyValue) {
                propertyValue = 'zipfile';
            }
        } else {
            propertyValue = properties[propertyName];
        }

        if (!propertyValue) {
            return undefined;
        }

        if (propertyName === Properties.ALL.itemUrl) {
            if (_isUrlTooLong(propertyValue, supportsCookies || false)) {
                return undefined;
            }
            propertyValue = encodeURIComponent(propertyValue);
        }

        url = url.replace(`{${propertyName}}`, propertyValue);
        part = regex.exec(url);
    }

    if (!!viewOnlyExperienceEnabled) {
        url += '&nocache=true';
    }

    return url;
}

export function getDownloadAsZipUrl(info: { [key: string]: string }, viewOnlyExperienceEnabled: boolean, env: string): string {
    let properties = {};
    setMicroServiceProperties(properties, info, env);
    return getNormalUrl(properties, Properties.ALL.zipUrl, undefined/*item*/,
        undefined/*method*/, viewOnlyExperienceEnabled, false/*supportsCookies*/);
}

export function setMicroServiceProperties(properties: MicroServicePropertiesValueType, info: { [key: string]: string }, env: string) {
    properties[Properties.ALL.zipUrl] = Properties.ZIP_URL;

    for (const propertyName of Properties.COMMON) {
        if (info[propertyName]) {
            properties[propertyName] = info[propertyName];
        }
    }

    properties[Properties.ALL.mediaBaseUrl] = fixMediaBaseUrl(properties[Properties.ALL.mediaBaseUrl], env);
}

function _isUrlTooLong(spItemUrl: string, supportsCookies: boolean) {
    // There is a limtation where request urls that are over 260 characters long do not work
    // This is hopefully a temporary problem and will be fixed asap
    if (supportsCookies) {
        // This limitation does not impact ODB
        // the easiest way to know whether these are ODB thumbnails is to see if we have auth cookies
        // (since they are only supported in ODB right now)
        return false;
    }

    // remove the host name of the url (https://msft.spoppe.com) since that doesn't count against the max length
    const index = spItemUrl.indexOf('/', 8);
    const url = spItemUrl.substring(index);
    // The mid tier adds some extra stuff onto the url so I am just guessing 215 for now
    return url.length > 215;
}

